import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { BodyComponent } from './components/body/body.component';
import { LoginComponent } from './components/login/login.component';

/*export const routes: Routes = [
  {
    path: ':portalID',
    component: BodyComponent
  },
  {
    path: '',
    component: ErrorComponent,
  }
];*/
export const routes: Routes = [
  {
    path: '',
    component: BodyComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app.routing.ts